export default "__VITE_ASSET__oElK2PgJ__"